module.exports = __webpack_public_path__ + "static/media/alc-end.9ffaa115.png";